'use strict';

var _ = require('lodash');
var GridUserActionButtonController = function GridUserActionButtonController($log, $scope, $rootScope, momentService, userSecureService, userActionService) {
  var selectedRows = [];
  $scope.flightAnalysisWriteAccess = userSecureService.hasAuthorization('flight-analysis', 'write');
  $scope.onButtonClick = function () {
    if ($scope.visible && !$scope.disabled) {
      sendSelectedRows();
    }
  };
  function sendSelectedRows() {
    if (_.isEmpty(selectedRows)) {
      return;
    }
    if ($scope.disabled) {
      $log.debug('User does not have WRITE permission to save the action');
      return;
    }
    var flightIdMap = _.chain(selectedRows).groupBy('flightId').map(function (rows, flightId) {
      return {
        flightId: flightId,
        rows: rows
      };
    }).value();
    userActionService.saveUserAction('FLIGHT', _.map(flightIdMap, 'flightId'), 'REVIEW');
  }
  $scope.onRowSelection = function (event, _selectedRows) {
    selectedRows = _selectedRows || [];
    $scope.visible = userActionService.isButtonVisible();
    $scope.disabled = !$scope.flightAnalysisWriteAccess || _selectedRows.length === 0;
    if (!$scope.visible) {
      sendSelectedRows();
    }
  };
};
GridUserActionButtonController.$inject = ['$log', '$scope', '$rootScope', 'MomentService', 'UserSecureService', 'UserActionService'];
module.exports = GridUserActionButtonController;